<template>
  <div class="stepbar-wrapper">
    <form-wizard
      :color="color"
      :title="title"
      :subtitle="subtitle"
      :shape="shape"
      :step-size="stepSize"
      :finish-button-text="finishButtonText"
      :back-button-text="backButtonText"
      :next-button-text="nextButtonText"
      @on-complete="$emit('on-complete')"
      @on-change="(prev, next) => $emit('on-change', prev, next)"
      ref="wizard"
    >
      <slot></slot>
    </form-wizard>
  </div>
</template>

<script>
import { FormWizard } from 'vue-form-wizard';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';

export default {
  name: 'Stepbar',
  components: {
    FormWizard
  },
  props: {
    color: { type: String, default: '#05a6ce' },
    title: { type: String, default: null },
    subtitle: { type: String, default: null },
    shape: { type: String, default: 'circle' },
    stepSize: { type: String, default: 'sm' },
    finishButtonText: { type: String, default: 'Tamamla' },
    backButtonText: { type: String, default: 'Geri' },
    nextButtonText: { type: String, default: 'İleri' }
  },
  methods: {
    reset() {
      if (this.$refs.wizard) {
        this.$refs.wizard.reset();
      }
    },
    nextTab() {
      if (this.$refs.wizard) {
        this.$refs.wizard.nextTab();
      }
    },
    prevTab() {
      if (this.$refs.wizard) {
        this.$refs.wizard.prevTab();
      }
    }
  }
};
</script>

<style>
/* Custom overrides for the label wizard to match the desired look */
.stepbar-wrapper .vue-form-wizard .wizard-icon-circle {
  border-width: 0 !important;
  width: 45px !important;
  height: 45px !important;
  font-size: 16px !important;
  background-color: #f3f2f7;
  border-color: #f3f2f7;
  color: #b4b7bd;
  font-weight: bold;

  /* Create gap for progress line */
  position: relative;
  z-index: 10;
  box-shadow: 0 0 0 8px #fff !important;
}

/* Completed Steps (Checked) */
.stepbar-wrapper .vue-form-wizard .wizard-icon-circle.checked {
  background-color: #28c76f !important;
  border-color: #28c76f !important;
  color: #fff !important;
}

/* Hide the number for checked steps and show checkmark */
.stepbar-wrapper .vue-form-wizard .wizard-icon-circle.checked .wizard-icon {
  display: none !important;
}

.stepbar-wrapper .vue-form-wizard .wizard-icon-circle.checked::after {
  content: '';
  position: absolute;
  top: 45%;
  left: 50%;
  width: 8px;
  height: 14px;
  border: solid white;
  border-width: 0 3px 3px 0;
  transform: translate(-50%, -50%) rotate(45deg);
}

/* Active Step */
.stepbar-wrapper .vue-form-wizard .wizard-nav-pills > li.active .wizard-icon-circle {
  background-color: #05a6ce !important;
  border-color: #05a6ce !important;
  color: #fff !important;
}

/* Steps after active but somehow checked (e.g., when returning back) */
.stepbar-wrapper .vue-form-wizard .wizard-nav-pills > li.active ~ li .wizard-icon-circle.checked {
  background-color: #f3f2f7 !important;
  border-color: #f3f2f7 !important;
  color: #b4b7bd !important;
}

/* Hide tick and show number for active step AND future steps */
.stepbar-wrapper
  .vue-form-wizard
  .wizard-nav-pills
  > li.active
  .wizard-icon-circle.checked
  .wizard-icon,
.stepbar-wrapper
  .vue-form-wizard
  .wizard-nav-pills
  > li.active
  ~ li
  .wizard-icon-circle.checked
  .wizard-icon {
  display: block !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0 !important;
}

.stepbar-wrapper .vue-form-wizard .wizard-nav-pills > li.active .wizard-icon-circle.checked::after,
.stepbar-wrapper
  .vue-form-wizard
  .wizard-nav-pills
  > li.active
  ~ li
  .wizard-icon-circle.checked::after {
  display: none !important;
}

.stepbar-wrapper .vue-form-wizard .wizard-progress-with-circle {
  height: 2px !important;
  background-color: #ebe9f1 !important;
}

/* Hide the progress line extending before the first step and after the last step */
.stepbar-wrapper .vue-form-wizard .wizard-nav-pills > li {
  position: relative;
}

.stepbar-wrapper .vue-form-wizard .wizard-nav-pills > li:first-child::before {
  content: '';
  position: absolute;
  top: 15px;
  left: -50px;
  width: calc(50% + 50px);
  height: 15px;
  background-color: #fff;
  z-index: 5;
}

.stepbar-wrapper .vue-form-wizard .wizard-nav-pills > li:last-child::after {
  content: '';
  position: absolute;
  top: 15px;
  right: -50px;
  width: calc(50% + 50px);
  height: 15px;
  background-color: #fff;
  z-index: 5;
}

/* Progress bar (connecting line) up to the active step */
.stepbar-wrapper .vue-form-wizard .wizard-progress-with-circle .wizard-progress-bar {
  background-color: #28c76f !important;
}

.stepbar-wrapper .vue-form-wizard .stepTitle {
  color: #b4b7bd !important;
  font-weight: normal !important;
  margin-top: 8px !important;
  font-size: 12px;
}

/* Completed Step Title */
.stepbar-wrapper
  .vue-form-wizard
  .wizard-nav-pills
  > li:not(.active)
  .wizard-icon-circle.checked
  + .stepTitle {
  color: #28c76f !important;
}

/* Active Step Title */
.stepbar-wrapper .vue-form-wizard .wizard-nav-pills > li.active .stepTitle,
.stepbar-wrapper .vue-form-wizard .wizard-nav-pills > li.active > a > .stepTitle {
  color: #05a6ce !important;
  font-weight: bold !important;
}

/* Titles for steps after the active one, even if checked */
.stepbar-wrapper
  .vue-form-wizard
  .wizard-nav-pills
  > li.active
  ~ li
  .wizard-icon-circle.checked
  + .stepTitle {
  color: #b4b7bd !important;
  font-weight: normal !important;
}

/* Dark mode specific overrides */
.dark-layout .stepbar-wrapper .vue-form-wizard .wizard-icon-circle {
  background-color: #151d32;
  border-color: #151d32;
  color: #b4b7bd;
  box-shadow: 0 0 0 8px #283046 !important;
}

/* Dark mode: Completed Steps (Checked) */
.dark-layout .stepbar-wrapper .vue-form-wizard .wizard-icon-circle.checked {
  background-color: #28c76f !important;
  border-color: #28c76f !important;
  color: #fff !important;
}

/* Dark mode: Active Step */
.dark-layout .stepbar-wrapper .vue-form-wizard .wizard-nav-pills > li.active .wizard-icon-circle {
  background-color: #05a6ce !important;
  border-color: #05a6ce !important;
  color: #fff !important;
}

.dark-layout
  .stepbar-wrapper
  .vue-form-wizard
  .wizard-nav-pills
  > li.active
  ~ li
  .wizard-icon-circle.checked {
  background-color: #151d32 !important;
  border-color: #151d32 !important;
  color: #b4b7bd !important;
}

.dark-layout .stepbar-wrapper .vue-form-wizard .wizard-progress-with-circle {
  background-color: #3b4253 !important;
}

.dark-layout .stepbar-wrapper .vue-form-wizard .stepTitle {
  color: #676d7d !important;
}

/* Dark mode: Completed Step Title */
.dark-layout
  .stepbar-wrapper
  .vue-form-wizard
  .wizard-nav-pills
  > li:not(.active)
  .wizard-icon-circle.checked
  + .stepTitle {
  color: #28c76f !important;
}

/* Dark mode: Active Step Title */
.dark-layout .stepbar-wrapper .vue-form-wizard .wizard-nav-pills > li.active .stepTitle,
.dark-layout .stepbar-wrapper .vue-form-wizard .wizard-nav-pills > li.active > a > .stepTitle {
  color: #05a6ce !important;
}

.dark-layout
  .stepbar-wrapper
  .vue-form-wizard
  .wizard-nav-pills
  > li.active
  ~ li
  .wizard-icon-circle.checked
  + .stepTitle {
  color: #676d7d !important;
  font-weight: normal !important;
}

/* Dark mode masks for edges */
.dark-layout .stepbar-wrapper .vue-form-wizard .wizard-nav-pills > li:first-child::before,
.dark-layout .stepbar-wrapper .vue-form-wizard .wizard-nav-pills > li:last-child::after {
  background-color: #283046 !important;
}
</style>
